export const WONDER_SCHEDULE_EARLY_ACCESS_LEAD_MINUTES = 2;
// Intentionally shared by the pre-start warning and pre-end notification cutoff.
export const WONDER_SCHEDULE_REMINDER_OFFSET_MINUTES = 5;
